<template>
  <div class="spa-list-desc">
    <div v-if="customDescription">
      <p
        v-for="(line, i) in customDescription"
        :key="'line-' + i"
      >
        <span
          v-show="showLine(i)"
          v-html="line"
        /><span v-if="isCollapsed && showLine(i)">..</span>
      </p>
    </div>
    <button
      v-if="isCollapsed"
      class="spa-list-desc__expand-btn"
      @click="setIsCollapsed(false)"
    >
      <Lang
        by-key="see-more"
        capitalize-first
      />
    </button>
    <button
      v-else
      class="spa-list-desc__expand-btn"
      @click="setIsCollapsed(true)"
    >
      <Lang
        by-key="see-less"
        capitalize-first
      />
    </button>
  </div>
</template>

<script lang="ts">
import { Location } from '@/core/ts/entity/Location'

import SpaSmallDescriptionRepository from '@/core/ts/repository/SpaSmallDescriptionRepository'

export default defineNuxtComponent({
  props: {
    location: { type: Object as PropType<Location | null>, default: () => null },
  },
  setup(props) {
    const locationLabel = props.location ? 'de '.concat(props.location.label) : ''

    const isCollapsed = ref<boolean>(true)

    const customDescription = props.location
      ? SpaSmallDescriptionRepository.getBySlug(props.location.slug || '', locationLabel)
      : SpaSmallDescriptionRepository.getNoLocationDesc()

    function setIsCollapsed(value: boolean) {
      isCollapsed.value = value
    }

    const showLine = (index: number) => {
      if (index === 0) {
        return true
      }

      return !isCollapsed.value
    }

    return {
      locationLabel,
      isCollapsed,
      setIsCollapsed,
      customDescription,
      showLine,
    }
  },
})
</script>

<style lang="scss" scoped>
.spa-list-desc {
  @apply px-2;

  @screen lg {
    @apply px-0;
  }

  &__expand-btn {
    @apply underline;
  }

  p {
    @apply my-2;
  }
}
</style>
